import { all, takeLatest, put } from 'redux-saga/effects';
import {
  setPrewievQuestionListSuccess,
  setPrewievQuizSuccess,
  setDisplayViewSuccess,
} from './action';

import {
  SET_PREVIEW_QUESTIONLIST,
  SET_PREVIEW_QUIZ,
  SET_PREVIEW_DISPLAY,
  SET_PREVIEW_QUIZ_SETTINGS
} from './constants';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val, type}>>}
 */
function* setQuestionListValue(actionObj) {
    yield put(setPrewievQuestionListSuccess(actionObj.val) );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchQuestionListValue(){
  yield  takeLatest( SET_PREVIEW_QUESTIONLIST, setQuestionListValue );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val, type}>>}
 */
function* setPreviewQuiz(actionObj) {
  yield put(setPrewievQuizSuccess(actionObj.val) );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchsetPreviewQuiz(){
  yield  takeLatest( SET_PREVIEW_QUIZ,  setPreviewQuiz );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val, type}>>}
 */
function*  setDisplayView(actionObj) {
  yield put(setDisplayViewSuccess(actionObj.val) );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchDisplayView(){
  yield  takeLatest(SET_PREVIEW_DISPLAY, setDisplayView );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val, type}>>}
 */
function*  setQuizSettings(actionObj) {
  yield put(setQuizSettingsSuccess(actionObj.val) );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchSetQuizSettings(){
  yield  takeLatest(SET_PREVIEW_QUIZ_SETTINGS, setQuizSettings );
}


function* prewievSaga(){
  yield all([
    watchQuestionListValue(),
    watchsetPreviewQuiz(),
    watchDisplayView(),
    watchSetQuizSettings()
  ]);
}

export default prewievSaga;
